import { frontendURL } from 'dashboard/helper/URLHelper';
import MetaCapiSettings from 'astrachat/meta_capi/MetaCapiSettings.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/astrachat/meta_capi'),
      name: 'astrachat_meta_capi',
      component: MetaCapiSettings,
      meta: {
        permissions: ['administrator', 'meta_capi_manage'],
      },
    },
  ],
};
